module.exports = __webpack_public_path__ + "static/media/waiter1.f15d619b.jpg";